module.exports = __webpack_public_path__ + "static/05_co-design-workshop.b8945ab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/05_co-design-workshop.jpg
// module id = 480
// module chunks = 110568472390859